module.exports = __webpack_public_path__ + "img/undo_white.4bebdfba.svg";